<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >


    <el-button type="text" @click="dialogVisible_adduser = true"> 添加受控设备 </el-button>

    <el-button type="text" @click="get_userinfo"> 刷新当前设备最新状态 </el-button>





    <el-dialog title="添加受控设备" :visible.sync="dialogVisible_adduser">
      <div style="margin: 20px;  "  ></div>
      <el-form label-position="right" label-width="100px"  >
        <el-form-item label="设备序列号">
          <el-input
            placeholder="设备序列号"
            v-model="addsn"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="选择结束日">
         <el-date-picker
               v-model="overtime"
               align="right"
               type="date"
               placeholder="选择结束日"
               :picker-options="pickerOptions">
             </el-date-picker>
        </el-form-item>
        <el-form-item label="选择结束日">
         <el-date-picker
               v-model="overtime"
               align="right"
               type="date"
               >
             </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_adduser = false">取 消</el-button>
        <el-button type="primary" @click="_admin_adduser">确 定</el-button>
      </span>
    </el-dialog>
    <el-table
        :data="userData"
        style="width: 2300px">
          <el-table-column
            prop="id"
            label="ID"
            width="60">
          </el-table-column>
          <el-table-column
            prop="sn"
            label="设备序列号"
            width="300">
          </el-table-column>
          <el-table-column
            prop="overtime"
            label="到期日期"
            width="180" >
        </el-table-column>
        <el-table-column
            prop="ispassed"
            label="当前状态">
            <template slot-scope="props">
               <el-tag type="success"  v-show= "props.row.ispassed == true"  >  状态正常 </el-tag>
               <el-tag type="danger"   v-show= "props.row.ispassed == false"  >  状态过期</el-tag>
            </template>
        </el-table-column>
        <el-table-column
            prop="statu"
            label="手动启用"
            width="100" >
            <template slot-scope="props">
              <el-button
                size="mini"
                type="success"
                icon="el-icon-wind-power"
                v-show= "props.row.statu == 2"
                @click.native.prevent="_enable_devs(props.$index, userData, 1188 )"
              >99年</el-button>
            </template>
        </el-table-column>
        <el-table-column
            prop="statu"
            label="手动禁用"
            width="100" >
            <template slot-scope="props">
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-wind-power"
                v-show= "props.row.statu == 1"
                @click.native.prevent="_disable_devs(props.$index, userData )"
              ></el-button>
            </template>
        </el-table-column>
        <el-table-column
            label="操作"  width="100" >
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              v-show= "props.row.statu == 2"
              @click.native.prevent="_enable_devs(props.$index, userData , 1 )"
            >1月</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="操作" width="100">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              v-show= "props.row.statu == 2"
              @click.native.prevent="_enable_devs(props.$index, userData  ,2 )"
            >2月</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="操作" width="100">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              v-show= "props.row.statu == 2"
              @click.native.prevent="_enable_devs(props.$index, userData , 3 )"
            >3月</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="操作" width="100">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              v-show= "props.row.statu == 2"
              @click.native.prevent="_enable_devs(props.$index, userData , 6 )"
            >6月</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              v-show= "props.row.statu == 2"
              @click.native.prevent="_enable_devs(props.$index, userData ,12 )"
            >1年</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              v-show= "props.row.statu == 2"
              @click.native.prevent="_enable_devs(props.$index, userData,24)"
            >2年</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              v-show= "props.row.statu == 2"
              @click.native.prevent="_enable_devs(props.$index, userData ,36)"
            >3年</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="删除">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              @click.native.prevent="_delete_devs(props.$index, userData  )"
            >Del</el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="月费用"
            prop="pay"   width="200" >
          <template slot-scope="props">
            <el-input placeholder="请输入内容" v-model="props.row.pay"  type="number" class="input-with-select">
              <el-button slot="append" icon="el-icon-circle-check" @click.native.prevent="_edit_pay(props.$index, userData ,props.row.pay)"></el-button>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
            label="ICCID"
            prop="iccid"   width="400" >
          <template slot-scope="props">
              <el-input placeholder="请输入内容" v-model="props.row.iccid" class="input-with-select">
                <el-button slot="append" icon="el-icon-cold-drink" @click.native.prevent="_edit_iccid(props.$index, userData ,props.row.iccid)"></el-button>
              </el-input>
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
function insertStr(source, start, newStr) {
	return source.slice(0, start) + newStr + source.slice(start+1)
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export default {
  data() {
    return {
      loading :false,
      trues:true,
      devkindkind:0,
      id:0,
      ddkjss:"",
      ddkjss2:"",
      token:"",
      dialogVisible:false,
      userData:[],
      userdevice:[],
      addsn:"",
      addusername:"",
      userid:0,
      zmask:"",
      overtime:"",
      z0:0,
      z1:0,
      z2:0,
      z3:0,
      z4:0,
      z5:0,
      z6:0,
      z7:0,
      zuser_name:"",
      dialogVisible_adduser:false,
       pickerOptions: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
                shortcuts: [{
                  text: '今天',
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  }
                }, {
                  text: '30日后',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 *30);
                    picker.$emit('pick', date);
                  }
                }, {
                  text: '一年后',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
                    picker.$emit('pick', date);
                  }
                }, {
                  text: '2年后',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365*2);
                    picker.$emit('pick', date);
                  }
                }, {
                  text: '3年后',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365*3);
                    picker.$emit('pick', date);
                  }
                }]
              },
    };
  },
  created(){
      this.id     = sessionStorage.getItem("id");
      this.token  = sessionStorage.getItem("token");
      this.get_userinfo();
  },
  methods: {
  change_id(){
    console.log(this.ddkjss);
    console.log(this.ddkjss2);
    let data = new FormData();
    data.append("id",          this.id );
    data.append("token",       this.token );
    data.append("ddkjss",      this.ddkjss );
    data.append("ddkjss2",     this.ddkjss2 );
    axios.post("user/fnckukei/edit_changeusername", data )
    .then(
      function(res) {
         if(res.data.res){
          this.get_userinfo();
          this.$notify.success({
            title: "Info",
            message: "修改成功",
            showClose: true
          });
         }else{
           this.$notify.success({
             title: "Info",
             message: "修改失败",
             showClose: true
           });
         }
      }.bind(this)
    )
    .catch(function(res) {
      console.log(res);
    });
  },
    _edit_iccid( row , datats , iccid){
      console.log(iccid);
      console.log(datats[row].sn);
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("sn",          datats[row].sn  );
      data.append("iccid",        iccid);
      data.append("devid",        datats[row].id);
      axios.post("user/fnckukei/edit_skdeviccid", data )
      .then(
        function(res) {
           if(res.data.res){
            this.get_userinfo();
            this.$notify.success({
              title: "Info",
              message: "修改成功",
              showClose: true
            });
           }else{
             this.$notify.success({
               title: "Info",
               message: "修改失败",
               showClose: true
             });
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    } ,
    _delete_devs( row , datats , pays){
      console.log(pays);
      console.log(datats[row].sn);
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("sn",          datats[row].sn);
      data.append("devid",       datats[row].id);
      axios.post("user/fnckukei/del_skdevsn", data )
      .then(
        function(res) {
           if(res.data.res){
             this.get_userinfo();
             this.$notify.success({
              title: "Info",
              message: "删除成功",
              showClose: true
            });
           }else{
             this.$notify.success({
               title: "Info",
               message: "删除失败",
               showClose: true
             });
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    _edit_pay( row , datats , pays){
      console.log(pays);
      console.log(datats[row].sn);
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("sn",          datats[row].sn  );
      data.append("pays",        pays);
      axios.post("user/fnckukei/edit_skdevpay", data )
      .then(
        function(res) {
           if(res.data.res){

            this.get_userinfo();
            this.$notify.success({
              title: "Info",
              message: "修改成功",
              showClose: true
            });
           }else{
             this.$notify.success({
               title: "Info",
               message: "修改失败",
               showClose: true
             });
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    _enable_devs( row , datats  , len ){
      const date = new Date();
      date.setTime(date.getTime() + 3600 * 1000 * 24 * 30*len );


      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("sn",          datats[row].sn  );
      data.append("overtime",    formatDate( date ) );
      axios.post("user/fnckukei/enable_skdevsn", data )
      .then(
        function(res) {
           console.log(res);
           if(res.data.res == true){
              this.get_userinfo();

              this.$notify.success({
                title: "Info",
                message: "操作成功",
                showClose: true
              });
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    _disable_devs( row , datats ){
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("sn",          datats[row].sn  );
      data.append("overtime",    formatDate( new Date("2019-12-12 23:59:59")) );
      axios.post("user/fnckukei/dis_skdevsn", data )
      .then(
        function(res) {
           console.log(res);
           if(res.data.res == true){
              this.get_userinfo();

              this.$notify.success({
                title: "Info",
                message: "已经发送禁用指令",
                showClose: true
              });
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    _admin_adduser(){
      if(this.addsn.length != 32 ){
        return;
      }
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("addsn",       this.addsn );
      data.append("overtime",    formatDate( new Date(this.overtime)) );
      axios.post("user/fnckukei/add_skdevsn", data )
      .then(
        function(res) {
           console.log(res);
           if(res.data.res == true){
              this.get_userinfo();
              this.dialogVisible_adduser = false;
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    get_userinfo() {
        let data = new FormData();
        data.append("id", this.id);
        data.append("token", this.token);
        axios
        .post("user/fnckukei/list_skdevsn", data )
        .then(
          function(res) {
             if(res.data.res){
               this.userData = res.data.results;
             }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px ;
}
 .el-select .el-input {
    width: 130px;
  }
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/admin_jifei.vue